export default {
  name: 'GameList',
  props: {
    showEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showDialog: false,
      image: '',
      banner: null,
      currentGame: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user || null;
    },
    loading() {
      return this.$store.state.loading || false;
    },
    gamesList() {
      return this.$store.state.game.gamesList || [];
    },
  },
  methods: {
    showGame(item) {
      this.currentGame = item;
      this.showDialog = true;
    },
    GetStatus(active) {
      return {
        color: active ? 'blue' : 'red',
        label: active ? 'Активно' : 'Завершено',
      };
    },
    GetPercentColor(percent) {
      return !percent || percent < 100 ? 'red--text' : 'green--text';
    },
    handleImageClick() {
      if (this.banner && this.banner.link) {
        window.open(this.banner.link, '_blank');
      }
    },
    setImgWidth() {
      const { image } = this.$refs;
      // eslint-disable-next-line no-restricted-globals
      image.$el.style.width = `${screen.width}px`;
    },
    changeDisplayImage() {
      // eslint-disable-next-line no-restricted-globals
      const { width } = screen;
      if (width <= 600) {
        this.image = this.banner ? this.banner.mobile_banner_url : '';
      } else {
        this.image = this.banner ? this.banner.banner_url : '';
      }
    },
  },
  async mounted() {
    // this.setImgWidth();
    this.changeDisplayImage();
    window.onresize = () => {
      // this.setImgWidth();
      this.changeDisplayImage();
    };
    if (this.user) {
      await this.$store.dispatch('game/GetGamesList', {
        profile_id: this.user.profile_id,
      });
      const response = await this.$store.getters.ax.post(
        '/posters/api/posters/by-group',
        { group: 'game' },
      );
      const { banners } = response.data;
      if (banners.length) {
        [this.banner] = banners;
        this.changeDisplayImage();
      }
    }
  },
};
